<nz-select [ngModel]="status" (ngModelChange)="onStatusChange($event)" [nzBorderless]="true" nzSize="small" [ngClass]="statusClass">
    <nz-option [nzValue]="EventDateStatusEnum.ON_SALE" nzLabel="On-Sale"></nz-option>
    <nz-option [nzValue]="EventDateStatusEnum.OFF_SALE" nzLabel="Off-Sale"></nz-option>
    <nz-option [nzValue]="EventDateStatusEnum.CANCELLED" nzLabel="Cancelled"></nz-option>
</nz-select>
